<template>
	<div class="ddb-p">
		<div class="ddb-c"></div>
		<div class="ddb-c"></div>
		<div class="ddb-c"></div>
	</div>
</template>
<style scoped lang="scss">
	.ddb-p {
		height: 40px;
		width: 40px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
		box-shadow: 0px 0px 3px white;
		border-radius: 4px;
	}
	.ddb-c {
		height: 10%;
		width: 70%;
		box-shadow: 0px 0px 3px white;
		background-color: white;
		border-radius: 4px/50%;
	}
</style>

